import { Controller } from 'stimulus'

import { jsRequest, pathname } from '@react/helpers/fetch'

export default class extends Controller {
  static targets = ['messages']

  connect() {
    const select = this.element.querySelector('select[name="diagnostic_material"]')
    if (select && select.value) {
      this.loadMessages(select.value)
    }
  }

  selectMaterial(event) {
    const materialId = event.target.value

    this.messagesTarget.innerHTML = ''

    if (!materialId) return

    this.loadMessages(materialId)
  }

  loadMessages(materialId) {
    const url = pathname({ path: this.data.get("route") + '/' + materialId, format: 'js' })
    jsRequest(url)
  }
}
